module.exports = __webpack_public_path__ + "static/6a6492e7.help-center-entry.png";